const IconCloseSmall = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.26 11.52L5.76 7.02L10.26 11.52L11.52 10.26L7.02 5.76L11.52 1.26L10.26 0L5.76 4.5L1.26 0L0 1.26L4.5 5.76L0 10.26L1.26 11.52Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconCloseSmall;
